export default __webpack_public_path__ + "static/media/add.032265e3.svg";